import { createContext, useContext } from 'react';

const TrackingContext = createContext<{ linksource: string | null }>({ linksource: null });

export const TrackingProvider = TrackingContext.Provider;
export const useTracking = () => useContext(TrackingContext);